module.exports = __webpack_public_path__ + "static/media/1-.81d7096e.webp";